import { reminderFeatures } from "@/mocks/comics";

export default function Reminder() {
  return (
    <section id="reminder" className="py-14 md:py-20 bg-background-50 relative overflow-hidden">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-12">
          <span className="inline-flex items-center gap-1.5 text-primary-600 text-sm font-medium">
            <i className="ri-notification-badge-line" />
            WHY US
          </span>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl text-foreground-950">追更省心，功能一步到位</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            从新章节提醒到阅读进度同步，我们让「追更」这件事变得简单又高效。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {reminderFeatures.map((f) => (
            <article
              key={f.title}
              className="group rounded-xl bg-background-100 border border-background-200 p-5 md:p-6 transition-all duration-300 hover:border-primary-300 hover:bg-background-50"
            >
              <div className="flex items-center justify-between">
                <span className="flex items-center justify-center w-12 h-12 md:w-14 md:h-14 rounded-xl bg-primary-500/10 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className={`${f.icon} text-xl md:text-2xl`} />
                </span>
                <span className="rounded-full bg-secondary-100 text-secondary-900 text-xs font-medium px-3 py-1 whitespace-nowrap">
                  {f.tag}
                </span>
              </div>
              <h3 className="mt-4 md:mt-5 font-medium text-foreground-950 text-base md:text-lg">{f.title}</h3>
              <p className="mt-2 text-sm md:text-base text-foreground-600 leading-relaxed">{f.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}